export const messages = {
  en: {
    vipDetail: {
      title: 'Member Details',
      vipId: 'Member ID:',
      vipName: 'Member Name:',
      vipTel: 'Member Phone:',
      sex: 'Gender:',
      levelName: 'Member Level:',
      birthday: 'Member Birthday:',
      startTime: 'Start Time:',
      endTime: 'End Time:',
      createTime: 'Create Time:',
      vipDetailUser: 'Member Users',
      vipDetailAccount: 'Member Accounts',
      vipDetailIntegral: 'Member Points',
      vipDetailIntegralDetail: 'Points Details',
      vipDetailOrder: 'User Orders',
      vipDetailRefundOrder: 'Refund Orders',
      vipDetailGroupOrders: 'Group Orders',
      vipDetailRefundGroupOrders: 'Group Refunds',
      vipDetailSeckillOrders: 'Seckill Orders',
      vipDetailAddress: 'Shipping Address'
    },
    vipDetailUser: {
      userId: 'User ID',
      userName: 'User Name',
      email: 'Email',
      address: 'Address',
      phone: 'Phone',
      registerTime: 'Register Time'
    },
    vipDetailIntegral: {
      id: 'ID',
      accountName: 'Account Name',
      objectType: 'Object Type',
      userId: 'User ID',
      phone: 'Phone',
      points: 'Points',
      merchant: 'Merchant',
      user: 'User'
    },
    vipDetailIntegralDetail: {
      id: 'ID',
      accountName: 'Account Name',
      accountId: 'Account ID',
      type: 'Type',
      relatedAccount: 'Related Account',
      points: 'Points',
      objectType: 'Object Type',
      objectId: 'Object ID',
      phone: 'Phone',
      transactionNo: 'Transaction No',
      transactionTime: 'Transaction Time',
      remark: 'Remark',
      transferOut: 'Transfer Out',
      transferIn: 'Transfer In',
      merchant: 'Merchant',
      user: 'User'
    },
    vipDetailOrder: {
      orderNo: 'Order No',
      platform: 'Platform',
      shop: 'Shop',
      type: 'Type',
      name: 'Name',
      quantity: 'Quantity',
      userName: 'User Name',
      paymentAmount: 'Payment Amount',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      service: 'Service',
      product: 'Product'
    },
    vipDetailRefundOrder: {
      orderNo: 'Order No',
      productName: 'Product Name',
      productSpec: 'Product Spec',
      userName: 'User Name',
      refundAmount: 'Refund Amount',
      orderStatus: 'Order Status',
      refundReason: 'Refund Reason',
      applyTime: 'Apply Time'
    },
    vipDetailGroupOrders: {
      orderId: 'Order ID',
      productName: 'Product Name',
      buyer: 'Buyer',
      groupLeader: 'Group Leader',
      purchaseQuantity: 'Purchase Quantity',
      groupPeople: 'Group People',
      groupPrice: 'Group Price',
      status: 'Status',
      rebateAmount: 'Rebate Amount',
      groupStartTime: 'Group Start Time',
      groupTime: 'Group Time',
      deadline: 'Deadline'
    },
    vipDetailRefundGroupOrders: {
      refundId: 'Refund ID',
      order: 'Order',
      product: 'Product',
      buyer: 'Buyer',
      purchaseQuantity: 'Purchase Quantity',
      groupPrice: 'Group Price',
      refundAmount: 'Refund Amount',
      refundType: 'Refund Type',
      refundReason: 'Refund Reason',
      status: 'Status',
      reviewNote: 'Review Note',
      selfRefund: 'Self Refund',
      groupFailedRefund: 'Group Failed Refund'
    },
    vipDetailSeckillOrders: {
      orderId: 'Order ID',
      productName: 'Product Name',
      buyer: 'Buyer',
      purchaseQuantity: 'Purchase Quantity',
      seckillPrice: 'Seckill Price',
      purchaseTime: 'Purchase Time',
      status: 'Status',
      deadline: 'Deadline',
      completed: 'Completed',
      pendingPayment: 'Pending Payment'
    },
    vipDetailAddress: {
      receiver: 'Receiver',
      receiverPhone: 'Receiver Phone',
      receiverAddress: 'Receiver Address',
      isDefault: 'Default',
      postalCode: 'Postal Code',
      createTime: 'Create Time'
    },
    common: {
      yes: 'Yes',
      no: 'No',
      male: 'Male',
      female: 'Female'
    }
  },
  zh: {
    vipDetail: {
      title: '会员详情',
      vipId: '会员编号：',
      vipName: '会员名称：',
      vipTel: '会员电话：',
      sex: '性别：',
      levelName: '会员等级：',
      birthday: '会员生日：',
      startTime: '开始时间：',
      endTime: '结束时间：',
      createTime: '添加时间：',
      vipDetailUser: '会员用户',
      vipDetailAccount: '会员账户',
      vipDetailIntegral: '会员积分',
      vipDetailIntegralDetail: '积分明细',
      vipDetailOrder: '用户订单',
      vipDetailRefundOrder: '退货订单',
      vipDetailGroupOrders: '拼团订单',
      vipDetailRefundGroupOrders: '拼团退单',
      vipDetailSeckillOrders: '秒杀订单',
      vipDetailAddress: '收货地址'
    },
    vipDetailUser: {
      userId: '用户编号',
      userName: '用户名称',
      email: '邮箱',
      address: '地址',
      phone: '手机号',
      registerTime: '注册时间'
    },
    vipDetailIntegral: {
      id: '编号',
      accountName: '账户名称',
      objectType: '对象类型',
      userId: '用户编号',
      phone: '手机号',
      points: '积分数',
      merchant: '商户',
      user: '用户'
    },
    vipDetailIntegralDetail: {
      id: '编号',
      accountName: '账户名称',
      accountId: '账户编号',
      type: '类型',
      relatedAccount: '关联账户',
      points: '积分数',
      objectType: '对象类型',
      objectId: '对象ID',
      phone: '手机号',
      transactionNo: '交易单号',
      transactionTime: '交易时间',
      remark: '备注',
      transferOut: '转出',
      transferIn: '转入',
      merchant: '商户',
      user: '用户'
    },
    vipDetailOrder: {
      orderNo: '订单号',
      platform: '平台',
      shop: '商铺',
      type: '类型',
      name: '名称',
      quantity: '数量',
      userName: '用户名称',
      paymentAmount: '支付金额',
      orderStatus: '订单状态',
      createTime: '创建时间',
      service: '服务',
      product: '商品'
    },
    vipDetailRefundOrder: {
      orderNo: '订单号',
      productName: '商品名称',
      productSpec: '商品规格',
      userName: '用户名称',
      refundAmount: '退款金额',
      orderStatus: '订单状态',
      refundReason: '退款原因',
      applyTime: '申请时间'
    },
    vipDetailGroupOrders: {
      orderId: '订单ID',
      productName: '商品名称',
      buyer: '购买者',
      groupLeader: '团长',
      purchaseQuantity: '购买数量',
      groupPeople: '拼团人数',
      groupPrice: '拼团金额',
      status: '状态',
      rebateAmount: '返佣金额',
      groupStartTime: '开团时间',
      groupTime: '拼团时间',
      deadline: '截止时间'
    },
    vipDetailRefundGroupOrders: {
      refundId: '退单编号',
      order: '订单',
      product: '商品',
      buyer: '购买人',
      purchaseQuantity: '购买数量',
      groupPrice: '拼团价格',
      refundAmount: '退款金额',
      refundType: '退款类型',
      refundReason: '退款原因',
      status: '状态',
      reviewNote: '审核说明',
      selfRefund: '自主退款',
      groupFailedRefund: '拼团失败退款'
    },
    vipDetailSeckillOrders: {
      orderId: '订单ID',
      productName: '商品名称',
      buyer: '购买者',
      purchaseQuantity: '购买数量',
      seckillPrice: '秒杀金额',
      purchaseTime: '购买时间',
      status: '状态',
      deadline: '截止时间',
      completed: '完成',
      pendingPayment: '待支付'
    },
    vipDetailAddress: {
      receiver: '收货人',
      receiverPhone: '收货电话',
      receiverAddress: '收货地址',
      isDefault: '默认',
      postalCode: '邮编',
      createTime: '创建时间'
    },
    common: {
      yes: '是',
      no: '否',
      male: '男',
      female: '女'
    }
  }
}